export const artifactsMapNames = {
  ancientCalendar: "Ancient Calendar",
  kingsStrategy: "Kings Strategy",
  propheticMonolith: "Prophetic Monolith",
  athenasCompass: "Athenas Compass",
  sandStone: "Sand Stone",
  wingedSandals: "Winged Sandals",
  timePendant: "Time Pendant",
  spiderRing: "Spider Ring",
  eternalGaze: "Eternal Gaze",
  mirrorOfDesire: "Mirror of Desire",
  slumberingStaff: "Slumbering Staff",
  wildSpirit: "Wild Spirit",
  darkMagicScroll: "Dark Magic Scroll",
  shepherdFlute: "Shepher's Flute",
  singingHarp: "Singing Harp",
  spectralEye: "Spectral Eye",
  lavaHeart: "Lava Heart",
  evilPearl: "Evil Pearl",
  lunarTear: "Lunar Tear",
  chroniclersDessert: "Chroniclers Dessert",
  flowerElfsTears: "Flower Elf's Tears",
  starPepper: "Star Pepper",
  fireproofHelmet: "Fireproof Helmet",
  platinumCaviar: "Platinum Caviar",
  crystalTruffle: "Crystal Truffle",
  kittyJade: "Kitty Jade",
  passionOil: "Passion Oil",
  swanWish: "Swan Wish",
  schorchingApplePie: "Schorching Apple Pie",
  snowHeart: "Snow Heart",
  topCheese: "Top Cheese",
  roastedMeat: "Roasted Meat",
  starfireBracelet: "Starfire Bracelet",
  meteorWatch: "Meteor Watch",
  wondrousTelescope: "Wondrous Telescope",
  sparklingHourglass: "Sparkling Hourglass",
  eternalWalnuts: "Eternal Walnuts",
  lapinNutmegs: "Lapin Nutmegs",
  finalSupper: "Final Supper",
  fruitOfEternity: "Fruit of Eternity",
  eternalRoseOil: "Eternal Rose Oil",
  eternalSaffron: "Eternal Saffron",
  rainbowBox: "Rainbow Box",
  memoryComb: "Memory Comb",
  dreamcatcher: "Dreamcatcher",
  crystalBall: "Crystal Ball",
  unicornHorn: "Unicorn Horn",
  dazzlingMask: "Dazzling Mask",
  galaxyBottle: "Galaxy Bottle",
  devilsPods: "Devils Pods",
  elvenWine: "Elven Wine",
  revealingPotion: "Revealing Potion",
  researchNotes: "Research Notes",
  kingdomAnnals: "Kingdom Annals",
  adamantineHammer: "Adamantine Hammer",
  glacialWine: "Glacial Wine",
  mapleWine: "Maple Wine",
  piningFromAfar: "Pining From Afar",
  theArtOfBuilding: "The Art of Building",
  heirloomWine: "Heirloom Wine",
  transmutationNotes: "Transmutation Notes",
  flowersBounty: "Flowers' Bounty",
  growthEssence: "Growth Essence",
  brewOfLife: "Brew of Life",
  goddessWings: "Goddess Wings",
};

export const artifactsMapRarity = {
  ancientCalendar: "legendary",
  kingsStrategy: "legendary",
  propheticMonolith: "legendary",
  athenasCompass: "legendary",
  sandStone: "legendary",
  wingedSandals: "legendary",
  timePendant: "legendary",
  spiderRing: "legendary",
  eternalGaze: "legendary",
  mirrorOfDesire: "legendary",
  slumberingStaff: "legendary",
  wildSpirit: "legendary",
  darkMagicScroll: "legendary",
  shepherdFlute: "epic",
  singingHarp: "epic",
  spectralEye: "epic",
  lavaHeart: "epic",
  evilPearl: "epic",
  lunarTear: "epic",
  chroniclersDessert: "epic",
  flowerElfsTears: "epic",
  starPepper: "epic",
  fireproofHelmet: "epic",
  platinumCaviar: "epic",
  crystalTruffle: "epic",
  kittyJade: "epic",
  passionOil: "epic",
  swanWish: "epic",
  schorchingApplePie: "epic",
  snowHeart: "epic",
  topCheese: "epic",
  roastedMeat: "epic",
  starfireBracelet: "epic",
  meteorWatch: "legendary",
  wondrousTelescope: "legendary",
  sparklingHourglass: "legendary",
  eternalWalnuts: "legendary",
  lapinNutmegs: "legendary",
  finalSupper: "legendary",
  fruitOfEternity: "legendary",
  eternalRoseOil: "legendary",
  eternalSaffron: "legendary",
  rainbowBox: "epic",
  memoryComb: "epic",
  dreamcatcher: "epic",
  crystalBall: "epic",
  unicornHorn: "epic",
  dazzlingMask: "epic",
  galaxyBottle: "epic",
  devilsPods: "epic",
  elvenWine: "epic",
  revealingPotion: "epic",
  researchNotes: "legendary",
  kingdomAnnals: "legendary",
  adamantineHammer: "legendary",
  glacialWine: "legendary",
  mapleWine: "legendary",
  piningFromAfar: "legendary",
  theArtOfBuilding: "legendary",
  heirloomWine: "legendary",
  transmutationNotes: "legendary",
  flowersBounty: "legendary",
  growthEssence: "legendary",
  brewOfLife: "legendary",
  goddessWings: "legendary",
};

export const artifactImages = {
  sandStone:
    "https://static.wikia.nocookie.net/lordsmobile/images/0/0a/Sand_Stone.png",
  wingedSandals:
    "https://static.wikia.nocookie.net/lordsmobile/images/d/d8/Winged_Sandals.png",
  timePendant:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/f5/Time_Pendant.png",
  shepherdFlute:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/47/Shepherd%27s_Flute.png",
  lavaHeart:
    "https://static.wikia.nocookie.net/lordsmobile/images/0/01/Lava_Heart.png",
  chroniclersDessert:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/91/Chronicler%27s_Dessert.png",
  kittyJade:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/f1/Kitty_Jade.png",
  schorchingApplePie:
    "https://static.wikia.nocookie.net/lordsmobile/images/e/e9/Scorching_Apple_Pie.png",
  fireproofHelmet:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/42/Fireproof_Helmet.png",
  slumberingStaff:
    "https://static.wikia.nocookie.net/lordsmobile/images/8/8b/Slumbering_Staff.png",
  wildSpirit:
    "https://static.wikia.nocookie.net/lordsmobile/images/0/06/Wild_Spirit.png",
  darkMagicScroll:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/fe/Dark_Magic_Scroll.png",
  spectralEye:
    "https://static.wikia.nocookie.net/lordsmobile/images/8/8b/Spectral_Eye.png",
  lunarTear:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/31/Lunar_Tear.png",
  starfireBracelet:
    "https://static.wikia.nocookie.net/lordsmobile/images/2/21/Starfire_Bracelet.png",
  starPepper:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/9e/Star_Pepper.png",
  crystalTruffle:
    "https://static.wikia.nocookie.net/lordsmobile/images/5/55/Crystal_Truffle.png",
  topCheese:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/ad/Top_Cheese.png",
  eternalGaze:
    "https://static.wikia.nocookie.net/lordsmobile/images/d/dc/Eternal_Gaze.png",
  spiderRing:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/10/Spider_Ring.png",
  mirrorOfDesire:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/70/Mirror_of_Desire.png",
  singingHarp:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/aa/Singing_Harp.png",
  evilPearl:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/75/Evil_Pearl.png",
  flowerElfsTears:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/7e/Flower_Elf%27s_Tears.png",
  snowHeart:
    "https://static.wikia.nocookie.net/lordsmobile/images/5/5b/Snow_Heart.png",
  roastedMeat:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/9b/Roasted_Meat.png",
  platinumCaviar:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/b6/Platinum_Caviar.png",
  kingsStrategy:
    "https://static.wikia.nocookie.net/lordsmobile/images/6/68/King%27s_Strategy.png",
  propheticMonolith:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/b7/Prophetic_Monolith.png",
  ancientCalendar:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/7d/Ancient_Calendar.png",
  athenasCompass:
    "https://static.wikia.nocookie.net/lordsmobile/images/8/8a/Athena%27s_Compass.png",
  wondrousTelescope:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/7a/Wondrous_Telescope.png",
  meteorWatch:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/1c/Meteor_Watch.png",
  sparklingHourglass:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/94/Sparkling_Hourglass.png",
  finalSupper:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/4f/Final_Supper.png",
  lapinNutmegs:
    "https://static.wikia.nocookie.net/lordsmobile/images/2/2e/Lapin_Nutmeg.png",
  eternalRoseOil:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/b4/Ethereal_Rose_Oil.png",
  dreamcatcher:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/32/Dreamcatcher.png",
  crystalBall:
    "https://static.wikia.nocookie.net/lordsmobile/images/e/e2/Crystal_Ball.png",
  memoryComb:
    "https://static.wikia.nocookie.net/lordsmobile/images/2/2d/Memory_Comb.png",
  devilsPods:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/79/Devil%27s_Pods.png",
  dazzlingMask:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/fc/Dazzling_Mask.png",
  rainbowBox:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/9d/Rainbow_Box.png",
  goldCinnamon:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/a4/Gold_Cinnamon.png",
  sirensGift:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/32/Siren%27s_Gift.png",
  royalScepter:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/ac/Royal_Scepter.png",
  nebulite:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/bb/Nebulite.png",
  starOfTheSea:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/4f/Star_of_the_Sea.png",
  telescope:
    "https://static.wikia.nocookie.net/lordsmobile/images/6/6c/Telescope.png",
  butterflyPipe:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/fb/Butterfly_Pipe.png",
  deepSeaFeast:
    "https://static.wikia.nocookie.net/lordsmobile/images/0/04/Deep_Sea_Feast.png",
  decorativePlate:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/a3/Decorative_Plate.png",
  cloudHawthorn:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/1a/Cloud_Hawthorn.png",
  midnightCrystal:
    "https://static.wikia.nocookie.net/lordsmobile/images/6/68/Midnight_Crystal.png",
  giantsHoneyWine:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/31/Giant%27s_Honey_Wine.png",
  gnomesMap:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/f7/Gnome%27s_Map.png",
  helmOfFaith:
    "https://static.wikia.nocookie.net/lordsmobile/images/0/09/Helm_of_Faith.png",
  lunarEgg:
    "https://static.wikia.nocookie.net/lordsmobile/images/6/64/Lunar_Egg.png",
  letheRosemary:
    "https://static.wikia.nocookie.net/lordsmobile/images/c/ca/Lethe_Rosemary.png",
  magicOnionSoup:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/74/Magic_Onion_Soup.png",
  caviarCracker:
    "https://static.wikia.nocookie.net/lordsmobile/images/6/69/Caviar_Cracker.png",
  oracleTablet:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/a7/Oracle_Tablet.png",
  goldenConch:
    "https://static.wikia.nocookie.net/lordsmobile/images/d/dc/Golden_Conch.png",
  starSalt:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/ba/Star_Salt.png",
  eternalSaffron:
    "https://static.wikia.nocookie.net/lordsmobile/images/7/7c/Eternal_Saffron.png",
  fruitOfEternity:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/a8/Fruit_of_Eternity.png",
  eternalWalnuts:
    "https://static.wikia.nocookie.net/lordsmobile/images/5/5d/Eternal_Walnuts.png",
  monocleOfTruth:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/98/Monocle_of_Truth.png",
  cosmosphere:
    "https://static.wikia.nocookie.net/lordsmobile/images/8/80/Cosmosphere.png",
  floatingRock:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/fe/Floating_Rock.png",
  divineArch:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/96/Divine_Arch.png",
  solarBottle:
    "https://static.wikia.nocookie.net/lordsmobile/images/b/bb/Solar_Bottle.png",
  elvenWine:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/1a/Elven_Wine.png",
  elvenCrown:
    "https://static.wikia.nocookie.net/lordsmobile/images/e/e9/Elven_Crown.png",
  elvenGown:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/10/Elven_Gown.png",
  bloodRose:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/4f/Blood_Rose.png",
  sunburst:
    "https://static.wikia.nocookie.net/lordsmobile/images/9/97/Sunburst.png",
  echoConch:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/ac/Echo_Conch.png",
  tidalCodex:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/3b/Tidal_Codex.png",
  imperialDecree:
    "https://static.wikia.nocookie.net/lordsmobile/images/3/3b/Imperial_Decree.png",
  marinersHeart:
    "https://static.wikia.nocookie.net/lordsmobile/images/e/e1/Mariner%27s_Heart.png",
  sirenQueen:
    "https://static.wikia.nocookie.net/lordsmobile/images/1/1d/Siren_Queen.png",
  sealedTome:
    "https://static.wikia.nocookie.net/lordsmobile/images/e/e9/Sealed_Tome.png",
  astrologicalRecord:
    "https://static.wikia.nocookie.net/lordsmobile/images/a/aa/Astrological_Record.png",
  statusOfAthena:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/4f/Statue_of_Athena.png",
  galaxyBottle:
    "https://static.wikia.nocookie.net/lordsmobile/images/d/d6/Galaxy_Bottle.png",
  arcticCandle:
    "https://static.wikia.nocookie.net/lordsmobile/images/c/c7/Arctic_Candle.png",
  gargoyle:
    "https://static.wikia.nocookie.net/lordsmobile/images/4/44/Gargoyle.png",
  triumphantFigure:
    "https://static.wikia.nocookie.net/lordsmobile/images/f/f3/Triumphant_Figure.png",
  sandCarpet:
    "https://static.wikia.nocookie.net/lordsmobile/images/2/28/Sand_Carpet.png",
};

export const artifactUpgrades = {
  ancientCalendar: {
    infAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    rangeHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
  },
  kingsStrategy: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
  },
  propheticMonolith: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
  },
  athenasCompass: {
    infAtk: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeAtk: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavAtk: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  sandStone: {
    infAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  wingedSandals: {
    infAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  timePendant: {
    infAtk: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
    infDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  spiderRing: {
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  eternalGaze: {
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  mirrorOfDesire: {
    cavAtk: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
    cavDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  slumberingStaff: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  wildSpirit: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  darkMagicScroll: {
    rangeAtk: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
    rangeDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  shepherdFlute: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  singingHarp: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  spectralEye: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  lavaHeart: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  evilPearl: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  lunarTear: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  chroniclersDessert: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  flowerElfsTears: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  starPepper: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  fireproofHelmet: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  platinumCaviar: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  crystalTruffle: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  kittyJade: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  passionOil: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  swanWish: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  schorchingApplePie: {
    infAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  snowHeart: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  topCheese: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  starfireBracelet: {
    rangeAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  roastedMeat: {
    cavAtk: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  meteorWatch: {
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
  },
  wondrousTelescope: {
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    rangeHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    infHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
  },
  sparklingHourglass: {
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
    infHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
  },
  eternalWalnuts: {
    cavHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  lapinNutmegs: {
    cavDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    rangeDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    rangeHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  finalSupper: {
    infDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    rangeDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    infHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  eternalRoseOil: {
    infDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavDef: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    cavHp: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  fruitOfEternity: {
    rangeHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  eternalSaffron: {
    infHp: {
      1: [3.0, 3.3, 3.6, 3.9, 4.2, 4.5, 6.0],
      2: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      3: [4.2, 4.62, 5.04, 5.46, 5.88, 6.3, 8.4],
      4: [5.1, 5.61, 6.12, 6.63, 7.14, 7.65, 10.2],
      5: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
      6: [7.2, 7.92, 8.64, 9.36, 10.08, 10.8, 14.4],
      7: [8.4, 9.24, 10.08, 10.92, 11.76, 12.6, 16.8],
      8: [9.6, 10.56, 11.52, 12.48, 13.44, 14.4, 19.2],
      9: [10.95, 12.04, 13.14, 14.23, 15.33, 16.42, 21.9],
      10: [12.3, 13.53, 14.76, 15.99, 17.22, 18.45, 24.6],
      11: [13.65, 15.01, 16.38, 17.74, 19.11, 20.47, 27.3],
      12: [15.0, 16.5, 18.0, 19.5, 21.0, 22.5, 30.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  rainbowBox: {
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  memoryComb: {
    cavHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  dreamcatcher: {
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    infDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  crystalBall: {
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  unicornHorn: {
    cavHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  dazzlingMask: {
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  galaxyBottle: {
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  devilsPods: {
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeDef: {
      1: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 2.0],
      2: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      3: [1.4, 1.54, 1.68, 1.82, 1.96, 2.1, 2.8],
      4: [1.7, 1.87, 2.04, 2.21, 2.38, 2.55, 3.4],
      5: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      6: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      7: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      8: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      9: [3.65, 4.01, 4.38, 4.74, 5.11, 5.47, 7.3],
      10: [4.1, 4.51, 4.92, 5.33, 5.74, 6.15, 8.2],
      11: [4.55, 5.0, 5.46, 5.91, 6.37, 6.82, 9.1],
      12: [5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 10.0],
    },
  },
  elvenWine: {
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  revealingPotion: {
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  researchNotes: {
    cavAtk: {
      1: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      2: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      3: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      4: [3.4, 3.74, 4.08, 4.42, 4.76, 5.1, 6.8],
      5: [4.0, 4.4, 4.8, 5.2, 5.6, 6.0, 8.0],
      6: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      7: [5.6, 6.16, 6.72, 7.28, 7.84, 8.4, 11.2],
      8: [6.4, 7.04, 7.68, 8.32, 8.96, 9.6, 12.8],
      9: [7.3, 8.03, 8.76, 9.49, 10.22, 10.95, 14.6],
      10: [8.2, 9.02, 9.84, 10.66, 11.48, 12.3, 16.4],
      11: [9.1, 10.01, 10.92, 11.83, 12.74, 13.65, 18.2],
      12: [10, 11.0, 12.0, 13.0, 14.0, 15.0, 20],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  kingdomAnnals: {
    cavAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
    rangeAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
  },
  adamantineHammer: {
    cavAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
    infAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
  },
  glacialWine: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  mapleWine: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  piningFromAfar: {
    infAtk: {
      1: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      2: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      3: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      4: [3.4, 3.74, 4.08, 4.42, 4.76, 5.1, 6.8],
      5: [4.0, 4.4, 4.8, 5.2, 5.6, 6.0, 8.0],
      6: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      7: [5.6, 6.16, 6.72, 7.28, 7.84, 8.4, 11.2],
      8: [6.4, 7.04, 7.68, 8.32, 8.96, 9.6, 12.8],
      9: [7.3, 8.03, 8.76, 9.49, 10.22, 10.95, 14.6],
      10: [8.2, 9.02, 9.84, 10.66, 11.48, 12.3, 16.4],
      11: [9.1, 10.01, 10.92, 11.83, 12.74, 13.65, 18.2],
      12: [10, 11.0, 12.0, 13.0, 14.0, 15.0, 20],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  theArtOfBuilding: {
    rangeAtk: {
      1: [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 4.0],
      2: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      3: [2.8, 3.08, 3.36, 3.64, 3.92, 4.2, 5.6],
      4: [3.4, 3.74, 4.08, 4.42, 4.76, 5.1, 6.8],
      5: [4.0, 4.4, 4.8, 5.2, 5.6, 6.0, 8.0],
      6: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      7: [5.6, 6.16, 6.72, 7.28, 7.84, 8.4, 11.2],
      8: [6.4, 7.04, 7.68, 8.32, 8.96, 9.6, 12.8],
      9: [7.3, 8.03, 8.76, 9.49, 10.22, 10.95, 14.6],
      10: [8.2, 9.02, 9.84, 10.66, 11.48, 12.3, 16.4],
      11: [9.1, 10.01, 10.92, 11.83, 12.74, 13.65, 18.2],
      12: [10, 11.0, 12.0, 13.0, 14.0, 15.0, 20],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  heirloomWine: {
    infAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    cavDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    cavHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  transmutationNotes: {
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  flowersBounty: {
    rangeAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
    infAtk: {
      1: [1.8, 1.98, 2.16, 2.34, 2.52, 2.7, 3.6],
      2: [2.16, 2.37, 2.59, 2.8, 3.02, 3.24, 4.32],
      3: [2.52, 2.77, 3.02, 3.27, 3.52, 3.78, 5.04],
      4: [3.06, 3.36, 3.67, 3.97, 4.28, 4.59, 6.12],
      5: [3.6, 3.96, 4.32, 4.68, 5.04, 5.4, 7.2],
      6: [4.32, 4.75, 5.18, 5.61, 6.04, 6.48, 8.64],
      7: [5.04, 5.54, 6.04, 6.55, 7.05, 7.56, 10.08],
      8: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      9: [6.57, 7.22, 7.88, 8.54, 9.19, 9.85, 13.14],
      10: [7.38, 8.11, 8.85, 9.59, 10.33, 11.07, 14.76],
      11: [8.19, 9.0, 9.82, 10.64, 11.46, 12.28, 16.38],
      12: [9.0, 9.9, 10.8, 11.7, 12.6, 13.5, 18],
    },
  },
  growthEssence: {
    cavAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    rangeDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    rangeHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  brewOfLife: {
    rangeAtk: {
      1: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      2: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      3: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      4: [4.08, 4.48, 4.89, 5.3, 5.71, 6.12, 8.16],
      5: [4.8, 5.28, 5.76, 6.24, 6.72, 7.2, 9.6],
      6: [5.76, 6.33, 6.91, 7.48, 8.06, 8.64, 11.52],
      7: [6.72, 7.39, 8.06, 8.73, 9.4, 10.08, 13.44],
      8: [7.68, 8.44, 9.21, 9.98, 10.75, 11.52, 15.36],
      9: [8.76, 9.63, 10.51, 11.38, 12.26, 13.14, 17.52],
      10: [9.84, 10.82, 11.8, 12.79, 13.77, 14.76, 19.68],
      11: [10.92, 12.01, 13.1, 14.19, 15.28, 16.38, 21.84],
      12: [12.0, 13.2, 14.4, 15.6, 16.8, 18.0, 24.0],
    },
    infDef: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
    infHp: {
      1: [1.6, 1.76, 1.92, 2.08, 2.24, 2.4, 3.2],
      2: [1.92, 2.11, 2.3, 2.49, 2.68, 2.88, 3.84],
      3: [2.24, 2.46, 2.68, 2.91, 3.13, 3.36, 4.48],
      4: [2.72, 2.99, 3.26, 3.53, 3.8, 4.08, 5.44],
      5: [3.2, 3.52, 3.84, 4.16, 4.48, 4.8, 6.4],
      6: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      7: [4.48, 4.92, 5.37, 5.82, 6.27, 6.72, 8.96],
      8: [5.12, 5.63, 6.14, 6.65, 7.16, 7.68, 10.24],
      9: [5.84, 6.42, 7.0, 7.59, 8.17, 8.76, 11.68],
      10: [6.56, 7.21, 7.87, 8.52, 9.18, 9.84, 13.12],
      11: [7.28, 8.0, 8.73, 9.46, 10.19, 10.92, 14.56],
      12: [8.0, 8.8, 9.6, 10.4, 11.2, 12.0, 16.0],
    },
  },
  goddessWings: {
    infHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
    cavHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
    rangeHp: {
      1: [1.2, 1.32, 1.44, 1.56, 1.68, 1.8, 2.4],
      2: [1.44, 1.58, 1.72, 1.87, 2.01, 2.16, 2.88],
      3: [1.68, 1.84, 2.01, 2.18, 2.35, 2.52, 3.36],
      4: [2.04, 2.24, 2.44, 2.65, 2.85, 3.06, 4.08],
      5: [2.4, 2.64, 2.88, 3.12, 3.36, 3.6, 4.8],
      6: [2.88, 3.16, 3.45, 3.74, 4.03, 4.32, 5.76],
      7: [3.36, 3.69, 4.03, 4.36, 4.7, 5.04, 6.72],
      8: [3.84, 4.22, 4.6, 4.99, 5.37, 5.76, 7.68],
      9: [4.38, 4.81, 5.25, 5.69, 6.13, 6.57, 8.76],
      10: [4.92, 5.41, 5.9, 6.39, 6.88, 7.38, 9.84],
      11: [5.46, 6.0, 6.55, 7.09, 7.64, 8.19, 10.92],
      12: [6.0, 6.6, 7.2, 7.8, 8.4, 9.0, 12.0],
    },
  },
};
